import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/cari-petani/$cariPetaniId/'
)({
  component: RouteComponent
})

function RouteComponent() {
  return <div>Hello "/_backoffice/klb-petani/cari-petani/$cariPetaniId/"!</div>
}
